export class User {
    id: string;
    firstName: string;
    lastName: string;
    createAccount: boolean;
    userName: string;
    fullName: string;
    phoneNumber: string;
    jobTitle: string;
    securityProfileId: number;
    securityProfile: string;
    organizationLevelIds: string[];
    organizationLevelName: string;
    roleId: string;
    roleName: string;
    failedLoginCount?: number;
    isLocked?: boolean;
    lastLoginDate?: string | Date | null;
    lastLoginMethod?: number | string | null;
    lockoutEndDate?: string | Date | null;
    status?: number | boolean | string | null;
    statusChangedByUserId?: string | null;
    statusChangedByUserName?: string | null;
    statusChangedDate?: string | Date | null;
}
